import React from 'react'
import { Login } from './Login';

export const stories = {
  'Login loading': () => (
    <Login
      getFieldDecorator={() => (x) => x}
      loading={true}
    />
  ),
  'Login default': () => (
    <Login
      getFieldDecorator={() => (x) => x}
      loading={false}
    />
  )
}



// WEBPACK FOOTER //
// ./src/Login/Login.storybook.js